module.exports = __webpack_public_path__ + "static/media/fonts-8-mobile.4deda09b.svg";